import { useParams } from "react-router-dom";
import IncomePlus from "./incomePlus";
import Prospect360 from "./prospect360";
import WebEdge from "./webEdge";
import Pricing from "../pricing";
import EasyApp from "./easyApp";
import GroupData from "./easyApp/group-data";
import { config } from "../../utils/config";
import { useAppSelector } from "../../store/hooks";

export default function Products(): ReactNode {
  const { token }: any = useAppSelector((state) => state.user);
  const params = useParams();

  const { id, subPage } = params;
  
  if (id === "EasyApp" && subPage === "GroupData") {
    return <GroupData />;
  }

  const renderProduct = () => {
    switch (params.id) {
      case "Prospect360":
        return <Prospect360 />;
      case "WebEdge":
        return <WebEdge />;
      case "Income+":
        return <IncomePlus />;
      case "OptiPricer":
        return <Pricing />;
      case "EasyApp":
        return <EasyApp />;
      case "EasyApp/GroupData":
        return <GroupData />;
      case "Customer360":
        const url = `${
          config.REACT_APP_CUSTOMER360_URL
        }?token=${encodeURIComponent(token)}`;
        window.location.href = url;
        return;

      default:
        return <div>{params.id ?? "No data"}</div>;
    }
  };

  return renderProduct();
}
